import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { RootState } from 'store';
import { API_CUSAT_EXPORT } from 'constants/api';
import downloadBlob from 'helpers/downloadBlob';
import { dayjs } from 'helpers';
import { storeName } from '../config';
import { buildCusatQuery } from './buildCusatQuery';

export const exportCusat = createAsyncThunk<void>(
  `${storeName}/export`,
  async (_, thunkAPI) => {
    const {
      cusat: { filters, sort },
    } = thunkAPI.getState() as RootState;

    return api.axios
      .get(`${API_CUSAT_EXPORT}?${buildCusatQuery(filters, sort)}`, {
        responseType: 'blob',
      })
      .then((response) => {
        downloadBlob(
          new Blob([response.data]),
          `CuSat_Data_${dayjs().format('DD.MM.YYYY')}.xlsx`,
        );
      })
      .catch((e) => thunkAPI.rejectWithValue(e.response?.data));
  },
);
